export { default } from "./KanbanPlayerCardContainer";
export type { KanbanPlayerCardProps } from "./KanbanPlayerCardContainer";
